import type { ReactNode } from 'react';

export type BadgeVariant = 'default' | 'blue' | 'green' | 'yellow' | 'red' | 'gray' | 'purple' | 'warning' | 'none';

interface BadgeProps {
  children: ReactNode;
  variant?: BadgeVariant;
  className?: string;
}

const variantStyles: Record<BadgeVariant, string> = {
  default: 'bg-gray-100 text-gray-800',
  blue: 'bg-blue-100 text-blue-800',
  green: 'bg-green-100 text-green-800',
  yellow: 'bg-yellow-100 text-yellow-800',
  red: 'bg-red-100 text-red-800',
  gray: 'bg-gray-100 text-gray-600',
  purple: 'bg-purple-100 text-purple-800',
  warning: 'bg-amber-100 text-amber-800',
  none: '',
};

export function Badge({ children, variant = 'default', className = '' }: BadgeProps) {
  return variant === 'none' ? null : (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${variantStyles[variant]} ${className}`}>
      {children}
    </span>
  );
}
